module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-date bg-color-skin-light-30"
  }, [_c('div', {
    staticClass: "col-xs-12 align-center"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.showTabDate) + " ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-759eb67b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/filter_date.vue
// module id = 3876
// module chunks = 1